export default __webpack_public_path__ + "CircularCustCapNum-Book.e7fb114b319ec578617befd7ac231a52.ttf";